module.exports = __webpack_public_path__ + "static/media/oiliness.7c2d7770.svg";